import { css } from "styled-components";
import { makeStyles } from "@material-ui/styles";

export function styledScrollbar(size = 10, color?: string) {
  return css`
    ::-webkit-scrollbar {
      width: ${size}px;
      height: ${size}px;
    }
    ::-webkit-scrollbar-track {
      background: ${(props) => props.theme.colors.scrollbar.track};
    }
    ::-webkit-scrollbar-thumb {
      background: ${(props) => color || props.theme.colors.scrollbar.thumb};
      border-radius: ${size / 2}px;
      cursor: pointer;
      transition: all ease 0.3s;
    }
    ::-webkit-scrollbar-thumb:hover {
      background: ${(props) => color || props.theme.colors.scrollbar.hover};
      cursor: pointer;
    }
    ::-webkit-scrollbar-corner {
      background: rgba(0, 0, 0, 0);
    }
  `;
}

export const useGlobalStyles = makeStyles(() => ({
  card: {
    boxShadow: "0px 3px 4px #DBDCDC",
    padding: "18px 24px",
    background: "#fff",
    borderRadius: "0.375rem",
  },
  lossText: {
    color: "#FF5432",
  },
  shadowDefault: {
    boxShadow: "0px 3px 4px #DBDCDC",
  },
}));
